export default __webpack_public_path__ + "static/media/cleber-dos-santos.e2b1f255.webp";